import React from 'react';
import PropTypes from 'prop-types';
import {Modal} from '@/components/atoms';
import {MODAL_TYPE} from '@/utils/constants/globalStyle';
import videoDisplayMockup from '@/assets/img/videoMockup.png';

const GuidelineModal = ({showGuidelines, setShowGuidelines}) => {
  if (!showGuidelines) return null;
  return (
    <Modal
      type={MODAL_TYPE.FLUID}
      showModal={showGuidelines}
      onCloseModal={() => setShowGuidelines(false)}
      title='Guidelines'
      text='Video Display'
      isDark
      showPrimaryButton={false}
      showSecondaryButton={false}
      onClickPrimaryButton={() => setShowGuidelines(false)}
      onClickSecondaryButton={() => {}}
      primaryButtonText=''
      secondaryButtonText=''
      className='guideline-modal'
      content={
        <div
          className='flex flex-col  overflow-y-auto rounded-lg pl-[16px] pr-[40px] pt-[20px] '
          style={{
            background: '#262626',
            maxHeight: '511px'
          }}>
          <p
            className='font-bold text-white'
            style={{
              fontSize: '16px',
              lineHeight: '22px',
              marginBottom: '16px'
            }}>
            PepsiConnect → Club+ → Videos
          </p>

          <div className='relative flex items-start gap-[16px]'>
            <div
              className='shrink-0 overflow-hidden rounded-xl'
              style={{width: '374px'}}>
              <img
                src={videoDisplayMockup}
                alt='Video Display Mockup'
                className='w-full'
              />
            </div>

            <div
              className='flex flex-col'
              style={{paddingTop: '340px', gap: '25px'}}>
              <div className='ml-[-60px] flex items-center gap-[8px]'>
                <div
                  style={{
                    width: '114px',
                    height: '3px',
                    background: '#0061C7'
                  }}
                />
                <span
                  className='whitespace-nowrap font-bold text-white'
                  style={{fontSize: '16px', lineHeight: '22px'}}>
                  Video Image
                </span>
              </div>
              <div className='ml-[-90px] mt-[10px] flex items-center gap-[8px]'>
                <div
                  style={{
                    width: '140px',
                    height: '3px',
                    background: '#0061C7'
                  }}
                />
                <span
                  className='whitespace-nowrap font-bold text-white'
                  style={{fontSize: '16px', lineHeight: '22px'}}>
                  Name
                </span>
              </div>
            </div>
          </div>
        </div>
      }
    />
  );
};

GuidelineModal.propTypes = {
  showGuidelines: PropTypes.bool.isRequired,
  setShowGuidelines: PropTypes.func.isRequired
};

export default React.memo(GuidelineModal);
